<script>
	export let backgroundImagePath

</script>

<div class="map-container">
	<img src={backgroundImagePath} alt="" />
</div>

<style lang="scss">
	.map-container {
		position: relative;
	}

	img {
		width: 100%;
		height: auto;
		border-radius: 50%;
		filter: brightness(0.98);
	}
</style>
